import type { FormSchema } from '@cli-types/core-engine/schema.js'
import type {
  DevModeLifecycleHookEvent,
  DevModeLifecycleHookExample
} from '@cli-types/next-adapter/generators.js'
import { getAllFormSchemaFields } from '@core-engine/schema/field-helpers/form-fields/get-all-form-schema-fields.js'
import { createFormInputObject } from './create-form-input-object.js'
import { createFormSubmissionObject } from './create-form-submission-object.js'
import { lifecycleHookCode } from './lifecycle-hook-code.js'
import { lifecycleHookContextExample } from './lifecycle-hook-context-example.js'
import { lifecycleHookIcon } from './lifecycle-hook-icon.js'
import { lifecycleHookId } from './lifecycle-hook-id.js'
import { lifecycleHookPhase } from './lifecycle-hook-phase.js'
export function buildFormDevModeLifecycleHooks(
  schema: FormSchema,
  adminImportAlias?: string
): DevModeLifecycleHookExample[] {
  const formLabel = schema.label
  const fields = getAllFormSchemaFields(schema)
  const input = createFormInputObject(fields)
  const data = createFormSubmissionObject(fields)
  const events: DevModeLifecycleHookEvent[] = [
    'beforeCreate',
    'afterCreate',
    'beforeDelete',
    'afterDelete'
  ]

  return events.map((event) => ({
    id: lifecycleHookId(event),
    label: event,
    event,
    phase: lifecycleHookPhase(event),
    icon: lifecycleHookIcon(event),
    language: 'ts',
    code: lifecycleHookCode(schema.name, event, formLabel, adminImportAlias),
    contextExample: lifecycleHookContextExample(event, schema.name, input, data, 'form')
  }))
}
